// extracted by mini-css-extract-plugin
export default {"goBack":"mfr-oNTa0H5a"};